export const onBoardText: Array<{ key: string; text: string }> = [
  { key: "consumerBar", text: "konsumer kann mit drag and drop auf den plan gezogen werden." }, // no itx
  { key: "connectButton", text: "Button channels können mit konsumer oder scenen verbunden werden" }, // no itx
];
